import { forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState } from "react"
import Block from "../Base/Block"
import ScrollView, { ScrollViewRef } from "../Base/ScrollView"
import View from "../Base/View"
import "./index.scss"
import Loading from "../Loading"
import Image from "../Base/Image"
import httpUtil from "../../utils/httpUtil"
import { toast } from "../../utils/toast"
import '../SpecificPannel/dialog.scss'

export interface RegionPickerRef {
    open: (initValue: string[]) => void;
}

const RegionPicker = forwardRef((prop: {
    onAddressChanged: (region: any[]) => void
}, ref) => {

    const [openType, setOpenType] = useState<number>(-1)  //-1：初始；0：关闭；1：打开
    const [regionInit, setRegionInit] = useState<string[]>(["请选择"]);//面板首次初始化时的地址
    const [resultRegion, setResultRegion] = useState<any[]>([]);//当前选择的地址各层级
    const [dict, setDict] = useState<any>({});//各级地址列表数据缓存字典，code ——> list
    const [addressList, setAddressList] = useState<any[]>([])//当前选择的地址各层级所在列表
    const [currentLevel, setCurrentLevel] = useState<number>(0);//当前选择的地址高亮索引
    const [isIniting, setIniting] = useState<boolean>(false);
    const [isLoading, setLoading] = useState<boolean>(false);
    const [loadFailed, setLoadFailed] = useState<boolean>(false);
    const scroller = useRef<ScrollViewRef>()

    useEffect(() => {
        if (openType === 0) {
            setTimeout(function () {
                setOpenType(-1)
            }, 250)
        }
    }, [openType]);


 

    /**
    * 根据地区编码获取辖区列表
    */
    const _getListByCode = useCallback((level: number, code: number, callback: (success: boolean, listResult: any, tip: string) => void, isUserClick = false) => {
        var that = this
        if (typeof dict[code + ''] !== typeof undefined) {
            var listResult = {
                data: {
                    Content: dict[code + ''],
                },
            }
            callback(true, listResult, '本地缓存')
            return
        }
        var apiParams = {}
        switch (level) {
            case 0:
                //省
                apiParams = {
                    apiName: 'province',
                }
                break
            case 1:
                //市区
                apiParams = {
                    apiName: 'city',
                    proviceCode: code,
                }
                break
            case 2:
                //地区、县
                apiParams = {
                    apiName: 'area',
                    cityCode: code,
                }
                break
            case 3:
                //乡镇、街道
                apiParams = {
                    apiName: 'street',
                    areaCode: code,
                }
                break
        }

        setLoading(true);
        httpUtil.link(
            apiParams,
            'GET',
            {},
            true,
            function (success: boolean, resData: any, tips: string) {
                var res = resData
                // 存字典
                if (success) {
                    if (level === 3 && res.data.Content.length > 0) {
                        var addPlaceholder = {
                            Name: '暂不选择',
                            Code: '-1',
                        }
                        res.data.Content.splice(0, 0, addPlaceholder)
                    }
                    var newDict = dict
                    newDict[code + ''] = res.data.Content
                    setDict(newDict)
                }
                callback(success, res, tips)
                setLoading(false)
                if (!success && isUserClick) {
                    toast.error('加载失败，稍后再试')
                }
            }
        )
    }, [])

    /**
   * 根据地址结果获取每个级别所在的地址同级列表
   */
    const _getListArrayByAddressName = useCallback((addressArray: any[],
        callback: (success: boolean, resultArray: any[], nameArray: any[]) => void,
        currentLevel = 0,
        upLevelCode = 0,
        resultListArray: any[] = [],
        resultNameArray: any[] = []) => {
        var that = this
        var resultArray = resultListArray
        var nameArray = resultNameArray
        var name = addressArray[currentLevel]
        if (currentLevel === 0 && isEmpty(name)) {
            name = '请选择'
        }
        // if(util.isEmpty(name)){
        //   callback(true, resultListArray, nameArray)
        //   return;
        // }
        _getListByCode(
            currentLevel,
            upLevelCode,
            function (success, res, tips) {
                if (success) {
                    resultArray[currentLevel] = res.data.Content
                    // 从结果中找到下一级列表对应的code
                    var codeTargetIndex = res.data.Content.findIndex((item: any) => {
                        return item.Name == name
                    })
                    if (codeTargetIndex !== -1) {
                        var code = res.data.Content[codeTargetIndex].Code
                        nameArray.push({
                            Name: name,
                            Code: code,
                            level: currentLevel,
                        })
                        if (currentLevel < addressArray.length && currentLevel + 1 < 4) {
                            _getListArrayByAddressName(
                                addressArray,
                                callback,
                                currentLevel + 1,
                                code,
                                resultArray,
                                nameArray
                            )
                        } else {
                            callback(true, resultArray, nameArray)
                        }
                    } else {
                        callback(true, resultArray, nameArray)
                    }
                } else {
                    callback(false, resultArray, nameArray)
                }
            }
        )
    }, [dict])

    /**
  * 由给定的地址初始化面板中各级列表数据
  */
    const _initDataByGivenRegion = useCallback((regionArray: string[]) => {
        setIniting(true)
        setLoadFailed(false);
        _getListArrayByAddressName(
            regionArray,
            function (success, list, names) {
                setResultRegion(names)
                setAddressList(list)
                setCurrentLevel(list.length - 1)
                setIniting(false)
                setLoadFailed(!success)
            }
        )
    }, [])



    /**
 * 改变高亮层级
 */
    const _changeLevel = useCallback((index: number) => {
        if (isLoading) {
            return
        }
        setCurrentLevel(index)
        scroller.current?.scrollTop(0)
    }, [isLoading, scroller])


    const _onCloseClick = useCallback(()=>{
        setRegionInit(["请选择"]);
        setOpenType(0);
    }, [])


    /**
       * 当前高亮层级选中地址变化
       */
    const _selectLevelValue = useCallback((index: number) => {
        if (isLoading) {
            return
        }
        var address = addressList[currentLevel][index]
        var currentRegion = resultRegion
        var currentAddresList = addressList
        if (currentLevel === 3) {
            // 选择到头了
            if (address.Code === '-1') {
                // 最后一级没有选择
                currentRegion = currentRegion.slice(0, currentLevel)
            } else {
                currentRegion[currentLevel] = address
            }
            setResultRegion(currentRegion)
            prop.onAddressChanged(currentRegion)
            _onCloseClick()
        } else {
            _getListByCode(
                currentLevel + 1,
                address.Code,
                function (success, res, tips) {
                    if (success) {
                        if (res.data.Content.length === 0) {
                            //选择到头了，需要清除该层级后面的数据
                            currentRegion[currentLevel] = address
                            setResultRegion(currentRegion.slice(
                                0,
                                currentLevel + 1
                            ))
                            setAddressList(currentAddresList.slice(
                                0,
                                currentLevel + 1
                            ))
                            prop.onAddressChanged(currentRegion)
                            _onCloseClick()
                        } else {
                            //还有下一级
                            currentRegion[currentLevel] = address
                            currentAddresList[currentLevel + 1] = res.data.Content
                            setResultRegion(currentRegion.slice(
                                0,
                                currentLevel + 1
                            ))
                            setAddressList(currentAddresList.slice(
                                0,
                                currentLevel + 2
                            ))
                            setCurrentLevel(currentLevel + 1)
                        }
                    }
                },
                true
            )
        }
    }, [addressList, currentLevel, resultRegion, addressList])

    useImperativeHandle(ref, () => ({
        open: (initValue: string[]) => {
            setOpenType(1)
            if (JSON.stringify(initValue) !== JSON.stringify(regionInit)) {
                setRegionInit(initValue)
                _initDataByGivenRegion(initValue)
            }
        }
    }))

    return <Block>
        <View
            className={
                'region-picker pannel-msk-state-' +
                (openType == -1 ? 'init' : openType != 0 ? 'open' : 'close')
            }
            onClick={() => {
                _onCloseClick()
            }}
        // onTouchMove={this._consumeTouchmove}
        ></View>
        <View
            className={
                'padding-safe-area region-picker pannel-state-' +
                (openType == -1 ? 'init' : openType != 0 ? 'open' : 'close')
            }
        // onTouchMove={this._consumeTouchmove}
        >
            <View className="pannel-title">配送至</View>
            {/*  已选择项  */}
            <ScrollView
                scrollX={true}
                scrollWithAnimation={true}
                className="result-list scrollbar-hide"
                enableBackToTop={false}
            >
                {addressList?.map((item, index) => {
                    return (
                        <View
                            key={item.key}
                            className={
                                'result-list-item ' +
                                (currentLevel === index ? 'result-list-item-active' : '')
                            }
                            data-index={index}
                            onClick={() => {
                                _changeLevel(index)
                            }}
                        >
                            {isEmpty(resultRegion?.[index])
                                ? '请选择'
                                : resultRegion?.[index]?.Name}
                        </View>
                    )
                })}
            </ScrollView>
            {/*  列表  */}
            <ScrollView
                className="pre-list scrollbar-hide"
                scrollY={true}
                ref={scroller}
                scrollWithAnimation={false}
                enableBackToTop={true}
            >
                {addressList?.[currentLevel]?.map((listItem: any, index: number) => {
                    return (
                        <View
                            key={listItem.Code}
                            className={
                                'pre-list-item ' +
                                (!isCurrentSelect(listItem, resultRegion, currentLevel)
                                    ? ''
                                    : 'pre-list-item-active') +
                                ' ' +
                                (listItem.Code == '-1' ? 'no-choice' : '')
                            }
                            data-index={index}
                            onClick={()=>{
                                _selectLevelValue(index)
                            }}
                        >
                            {listItem.Name}
                            <Image
                                className="current-select"
                                src={require('../../images/selected.png')}
                            ></Image>
                        </View>
                    )
                })}
            </ScrollView>
            {(isLoading || isIniting) && (
                <Loading
                    style={{
                        width: 25,
                        height: 25,
                        position: "absolute",
                        bottom: 150,
                        left: "47%",
                        opacity: 0.5
                    }}
                ></Loading>
            )}
            {currentLevel == -1 && loadFailed && (
                <View className="retry-btn" onClick={() => {
                    _initDataByGivenRegion(resultRegion)
                }}>
                    加载失败，点击重试
                </View>
            )}
        </View>
    </Block>
})


export default RegionPicker;

function isEmpty(item: any) {
    return item == null || typeof item == typeof undefined
}
function isCurrentSelect(addrss: any, nameList: any[], currentLevel: number) {
    if (isEmpty(nameList[currentLevel])) {
        return false
    }
    return addrss.Name === nameList[currentLevel].Name
}